import { type ReactNode } from 'react';

export interface WorkspaceItemTooltipProps {
  // The object type, rendered as the tooltip's header (not a key-value row).
  readonly typeLabel: string;
  readonly id: number;
  readonly name: string;
  readonly description?: string | null;
  readonly zoneName?: string | null;
  // Type-specific extra rows (each a `<tr><td>label</td><td>value</td></tr>`).
  readonly children?: ReactNode;
}

/**
 * The tooltip body for a workspace item: a small left-aligned table with the
 * type as a header, then the common fields, then any per-type extras. Folder
 * path is intentionally omitted — it's not on WorkspaceItem and the tree already
 * shows where the item lives.
 */
export const WorkspaceItemTooltip = ({ typeLabel, id, name, description, zoneName, children }: WorkspaceItemTooltipProps) => (
  <table className="workspace-item-tooltip">
    <tbody>
      <tr>
        <th colSpan={2} className="workspace-item-tooltip-type">
          {typeLabel}
        </th>
      </tr>
      <tr>
        <td>Id</td>
        <td>{id}</td>
      </tr>
      <tr>
        <td>Name</td>
        <td>{name}</td>
      </tr>
      {description?.trim() ? (
        <tr>
          <td>Description</td>
          <td>{description}</td>
        </tr>
      ) : null}
      {zoneName ? (
        <tr>
          <td>Zone</td>
          <td>{zoneName}</td>
        </tr>
      ) : null}
      {children}
    </tbody>
  </table>
);
